module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/montserrat-light-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/montserrat-light-webfont.eot
// module id = 342
// module chunks = 0